/**
 * @namespace SearchFilter
 * @aka Planet.SearchFilter
 */
Planet.SearchFilter = (function ($) {

  /**
   * ------------------------------------------------------------------------
   * Constants
   * ------------------------------------------------------------------------
   */

  var NAME = 'searchFilter';
  var DATA_KEY = 'planet.' + NAME;
  var EVENT_KEY = '.' + DATA_KEY;
  var DATA_API_KEY = '.data-api';
  var JQUERY_NO_CONFLICT = $.fn[NAME];

  var Event = {
    PJAX_DATA_API: 'pjax:end' + EVENT_KEY + DATA_API_KEY
  };

  var Selector = {
    DATA_SPY: 'form.planet-search'
  };

  var KLASSEN_SLIDER_MAX = 13;

  /*
   TODO: private helpers go here.
   */

  /**
   * ------------------------------------------------------------------------
   * Class Definition
   * ------------------------------------------------------------------------
   */
  var SearchFilter = function () {

    function SearchFilter(element) {
      var self = this;

      // protected
      self.element = element;
      self.$element = $(self.element);

      self.$buttonCollapse = self.$element.find('[data-toggle="collapse"]');
      self.$buttonsTab = self.$element.find('[data-toggle="tab"]');
      self.$wrapper = self.$element.closest('.container.planet-search');

      var $klassenWrapper = self.$element.find("#planet-klassen");
      self.$klassenRadios = $klassenWrapper.find('.form-fieldset-radio input:radio');
      self.$klassenRadioGrundschule = $klassenWrapper.find("#schooltypes0");
      self.$klassenRadioSekundarstufe1 = $klassenWrapper.find("#schooltypes1");
      self.$klassenRadioSekundarstufe2 = $klassenWrapper.find("#schooltypes2");
      self.$klassenButton = $klassenWrapper.find(".btn-filter");

      self.$klassenChecks = $klassenWrapper.find(".form-fieldset-checkbox input:checkbox");

      self.$klassenSlider = $klassenWrapper.find(".double-slider-wrapper");
      self.$klassenSliderTrack = self.$klassenSlider.find(".slider-track");
      self.$klassenSlider1 = self.$klassenSlider.find("#slider-1");
      self.$klassenSlider2 = self.$klassenSlider.find("#slider-2");
      self.$klassenSliderTextRange1 = self.$klassenSlider.find("#range1");
      self.$klassenSliderTextRange2 = self.$klassenSlider.find("#range2");

      self._openClose();
      self._addEventListeners();
      self._addFilterButton();
      self._changeFilterButton();
      self._openFilterOnSearchpage();
      self._searchFilterDistance();
    }

    /****
     * Sorgt dafür, dass alle Tabs beim Zuklappen der Einstellungen geschlossen werden
     * und dass ein Tab geschlossen werden kann, beim Zuklappen dieses Tabs.
     * @private
     */
    SearchFilter.prototype._openClose = function _openClose() {
      var self = this;

      self.$buttonCollapse.on('click', function (){
        self.$buttonsTab.each(function (){
          handleTab($(this), false);
        });

        if ($("body").find(".suchseite").length) {
          if ($(".suchseite .collapse").hasClass("show")) {
            $("#content").removeClass("has-open-filter");
          } else {
            $("#content").addClass("has-open-filter");
          }
        }
      });

      self.$buttonsTab.each(function (){
        $(this).on('click', function (event){
          handleTab($(this), true);
        });
      });

      function handleTab(tabButton, openTab) {
        var tab = $('' + tabButton.attr('href'));

        if(tab.hasClass('active')){
          //tab.js von jQuery reagiert zeitgleich und klappt wieder auf. Daher ein
          //kleiner Zeitversatz und die Tabs werden zugeklappt.
          window.setTimeout(function (){
            tab.removeClass('active');
            tabButton.removeClass('active');
            tabButton.attr('aria-selected', false);
            self.$wrapper.removeClass('tab-open');
          }, 100);
        }else if(openTab) {
          self.$wrapper.addClass('tab-open');
        }
      }
    };

    SearchFilter.prototype._addEventListeners = function _addEventListeners() {
      this.$klassenRadios.on("change", this._classesReset.bind(this, false, true, true));
      this.$klassenSlider.on("change", this._classesReset.bind(this, true, false, true));
      this.$klassenChecks.on("change", this._classesReset.bind(this, true, true, false));

      $("#planet-faecher").on("change", this._changeFilterButton.bind(this, "#planet-faecher"));
      $("#planet-medien").on("change", this._changeFilterButton.bind(this, "#planet-medien"));
      $("#planet-klassen").on("change", this._changeFilterButton.bind(this, "#planet-klassen"));
    }

    SearchFilter.prototype._classesReset = function _classesReset(resetRadios, resetSlider, resetChecks) {
      if (resetRadios) {
        this.$klassenRadios.prop("checked", false);
      }

      if (resetSlider) {
        if (this.$klassenRadioGrundschule.is(":checked")) {
          this._adjustKlassenSlider(1, 4);
        } else if (this.$klassenRadioSekundarstufe1.is(":checked")) {
          this._adjustKlassenSlider(5, 10);
        } else if (this.$klassenRadioSekundarstufe2.is(":checked")) {
          this._adjustKlassenSlider(11, 13);
        } else {
          this._adjustKlassenSlider(1, 13);
        }
      }

      if (resetChecks) {
        this.$klassenChecks.prop("checked", false);
      }
    }

    SearchFilter.prototype._adjustKlassenSlider = function _adjustKlassenSlider(value1, value2) {
      this.$klassenSlider1.val(value1);
      this.$klassenSlider2.val(value2);
      this.$klassenSliderTextRange1.text(value1);
      this.$klassenSliderTextRange2.text(value2);
      var percent1 = ((parseInt(value1) - 1) / (KLASSEN_SLIDER_MAX - 1)) * 100 + '%';
      var percent2 = ((parseInt(value2) - 1) / (KLASSEN_SLIDER_MAX - 1)) * 100 + '%';
      this.$klassenSliderTrack.css("background", "rgba(0, 0, 0, 0) linear-gradient(to right, rgb(202, 202, 202) " + percent1 + " , rgb(65, 120, 245) " + percent1 + " , rgb(65, 120, 245) " + percent2 + " , rgb(202, 202, 202) " + percent2 + ") repeat scroll 0% 0%");
    }

    SearchFilter.prototype._addFilterButton = function _addFilterButton() {
      $("#planet-faecher").prepend('<button disabled class="btn btn-filter">Filter anwenden</button>');
      $("#planet-medien").prepend('<button disabled class="btn btn-filter">Filter anwenden</button>');
      $("#planet-klassen").prepend('<button disabled class="btn btn-filter">Filter anwenden</button>');
    }

    SearchFilter.prototype._changeFilterButton = function _changeFilterButton(parent) {
      var $buttonToChange = $(parent).find(".btn-filter");
      $buttonToChange.removeAttr("disabled");
    }

    SearchFilter.prototype._openFilterOnSearchpage = function _openFilterOnSearchpage() {
      if ($("body").find(".suchseite").length) {
        $('.suchseite button[data-toggle="collapse"]').click();
        $(".search-tags-list").not(":empty").addClass("open-filter");
        $("#content").addClass("has-open-filter");
      }
    }

    SearchFilter.prototype._searchFilterDistance = function _searchFilterDistance() {
      var $trigger = $('button[data-toggle="collapse"]');
      var $target = $(".search-tags-list").not(":empty");

      $trigger.on("click", function(){
        if ($(this).hasClass("collapsed")) {
          $target.addClass("open-filter");
        } else {
          $target.removeClass("open-filter");
        }
      })
    }

    // public
    SearchFilter.prototype.dispose = function dispose() {
      this.$element.off(EVENT_KEY);

      this.$element = null;
      this.element = null;

      $(document).off(EVENT_KEY);
    };

    // static
    SearchFilter._jQueryInterface = function _jQueryInterface() {
      return this.each(function () {
        var data = $(this).data(DATA_KEY);

        if (!data) {
          data = new SearchFilter(this);
          $(this).data(DATA_KEY, data);
        }
      });
    };

    return SearchFilter;
  }();

  /**
   * ------------------------------------------------------------------------
   * Data Api implementation
   * ------------------------------------------------------------------------
   */
  $(Selector.DATA_SPY).each(function () {
    var $element = $(this);
    SearchFilter._jQueryInterface.call($element, $element.data());
  });
  $(document).on(Event.PJAX_DATA_API, function (event, xhr, options) {
    $(options.container).find(Selector.DATA_SPY).each(function () {
      var $element = $(this);
      SearchFilter._jQueryInterface.call($element, $element.data());
    });
  });

  /**
   * ------------------------------------------------------------------------
   * jQuery
   * ------------------------------------------------------------------------
   */
  $.fn[NAME] = SearchFilter._jQueryInterface;
  $.fn[NAME].Constructor = SearchFilter;
  $.fn[NAME].noConflict = function () {
    $.fn[NAME] = JQUERY_NO_CONFLICT;
    return SearchFilter._jQueryInterface;
  };

  return SearchFilter;

})(window.jQuery);

/**
 * ------------------------------------------------------------------------
 * Verschieben der Suchfilter-Tags
 * ------------------------------------------------------------------------
 */
$( document ).ready(function() {
  $('.planet-search-tags').addClass("container").insertAfter('.container.planet-search');
});
